import Bnbbc from './Bnbbc';

export default Bnbbc;
